import axiosInstance from '../common/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

// Save Supplier Info
export async function saveShipperInfo(data) {
  return axiosInstance.post(`${backendUrl}/api/shippers`, data);
}


export async function getvehicleType() {
  return axiosInstance.get(`${backendUrl}/api/lookup-values/type/VEHICLE_TYPE`);
}



export async function fetchShipperInfo(id) { 
 
  return axiosInstance.get(`${backendUrl}/api/shippers/by_user/${id}`);
}


